/**
 * Format currency
 * @param currency
 *
 * @example
 * formatCurrency(1000) // $ 1 000.00
 * formatCurrency(985.94) // $ 985.94
 */
export const formatCurrency = (currency: number): string => {
  return `$ ${currency.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&\u00A0')}`;
};
